import { RootState } from "@/store/store";
import { cloudChiprApi } from "@/services/cloudchipr.api";
import { infrastructureArchitectureDiagramFixedCacheKey } from "@/store/infrastructure-architecture/utils/constants/constants";
import { selectInfrastructureArchitectureStateInLocalStorage } from "@/store/infrastructure-architecture/utils/helpers/selectInfrastructureArchitectureStateInLocalStorage";

const endpoint = cloudChiprApi.endpoints.postUsersMeSolutionArchitects.select;

export const infrastructureArchitectureHierarchySelector = (
  state: RootState,
) => {
  const response = endpoint(infrastructureArchitectureDiagramFixedCacheKey)(
    state,
  );
  const { hierarchy } = selectInfrastructureArchitectureStateInLocalStorage();

  return !response?.isUninitialized && !response?.isLoading
    ? response?.data?.complete_architecture?.regions
    : hierarchy;
};
